'use strict';

angular.module('licensure.helpers')
    .factory('ApiIntercepter', ['$q', '$rootScope', 'Authentication', '$window', 'localStorageService', function ($q, $rootScope, Authentication, $window, localStorageService) {
        var regexDateFormat1 = /^\d{4}-\d{2}-\d{2}\s?T?\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/g;
        var regexDateFormat2 = /^\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/g;
        var regexDateFormat3 = /^\d{1,2}\/\d{1,2}\/\d{4}\s\d{1,2}:\d{2}:\d{2}\s(AM|PM)?$/g;
        var regexDateFormat4 = /^\d{1,2}\/\d{1,2}\/\d{4}$/g;
        const notesDateArr = ['note', 'note_', 'note_display', 'last_monitoring_action_note'];

        var convertDateStringsToDates = function (input) {
            // Ignore things that aren't objects.
            if (typeof input !== "object") {
                return;
            }

            //Ignore certain custom form answers (they could have custom options that look like dates) - multi select, drop down, checkbox, slush box, radio button, search
            if (input && input["data_point_id"] == null && input["section_id"] != null && (input["service"] == null || input["service"] == "") && input["question_type_id"] != null && ['1ae5aa55-c71a-4e13-961c-511597b4d78c', '3b114d4f-39f9-4ee3-8692-046d6277e326', '67948a8a-55e8-45cf-aa27-8928872a7430', '79af640c-4420-4466-9b8b-63b9ea805b50', 'c335ef14-5e37-4350-b760-dea16764fcfb', '2cd698ad-dcc7-4990-acd0-c0db28e69a32'].indexOf(input["question_type_id"]) >= 0) {
                return;
            }

            if (input && input["recordedDate"] != null) {
                return;
            }

            for (var key in input) {
                if (!input.hasOwnProperty(key)) continue;
                const keepDate = notesDateArr.includes(key);
                var fbAnswerDate = false;

                var value = input[key];
                if (input["question_type_id"] === 'e0bfd5b6-c52a-43fe-b564-6ffa8882b334') { // text question_type.id
                    // formCheck checks (license) || (exam & inspection) forms as well as Default Value
                    const formCheck = (input["value"] !== undefined && key === 'value' && input["group_id"] !== undefined) || input["default_value"] !== undefined && key === 'default_value' && input["section_id"] !== undefined;
                    if (formCheck) {
                        fbAnswerDate = regexDateFormat4.test(value);
                    }
                }

                var match;
                // Check for string properties which look like dates.
                if (!keepDate && typeof value === "string" && ((match = value.match(regexDateFormat2)) || (match = value.match(regexDateFormat3)) || (match = value.match(regexDateFormat4)))) {
                    input[key] = new Date(value);
                    if (fbAnswerDate) {
                        input[key] = input[key].toLocaleDateString('en-US');
                    }
                }
                else if (typeof value === "string" && (match = value.match(regexDateFormat1))) {
                    // the regexDateFormat1 has the trailing uppercase 'Z' as optional so adding a check for that here
                    if (value.charAt(value.length - 1) !== 'Z') {
                        input[key] = new Date(value + 'Z');
                    }
                    else {
                        input[key] = new Date(value);
                    }
                }
                else if (typeof value === "object") {
                    // Recurse into object
                    convertDateStringsToDates(value);
                }
                else {
                    //console.log(value);
                }
            }

            return;
        }

        var loadingCount = 0;

        return {
            request: function (config) {
                var d = $q.defer();
                config = config || {};
                config.headers = config.headers || {};

                if ($rootScope.$state != null && $rootScope.$state.current != null) {
                    config.headers.Angularstate = $rootScope.$state.current.name;
                }

                if (config.url.startsWith(apiLocation + '/api/')) {
                    if (++loadingCount > 0) $rootScope.$broadcast('loading:progress');
                    if (($rootScope.$state.current.data != undefined && $rootScope.$state.current.data.loginRequired) || ($rootScope.$state.current.params != undefined && $rootScope.$state.current.params.loginRequired)) {
                        // Make sure they have a token (for internal, it creates a new one if they don't), and if not make them log in again
                        Authentication.get($rootScope.$state.current.data.isPortal).then(function (authData) {
                            if (authData) {
                                // they have token
                                config.headers.Authorization = 'Bearer ' + authData.access_token;
                            }
                            else {
                                // they don't
                                if ($rootScope.$state.current.data.isPortal) {
                                    $rootScope.$state.go("portal.menus.login", { messages: ["Your session has expired. Please log in again to continue."] });
                                }
                                else {
                                    // redirect to internal login
                                }

                            }
                            d.resolve(config);
                        });
                    }
                    // there are cases where login isn't required, but we want to get the account data anyway (redirecting from a CF page to a .NET page)
                    else if ($rootScope.$state.current.data != undefined || $rootScope.$state.current.params != undefined) {
                        Authentication.get($rootScope.$state.current.data.isPortal).then(function (authData) {
                            if (authData) {
                                // they have token
                                config.headers.Authorization = 'Bearer ' + authData.access_token;
                            }
                            d.resolve(config);
                        });
                    }
                    else {
                        d.resolve(config);
                    }
                }
                else {
                    d.resolve(config);
                }

                return d.promise;
            },

            response: function (response) {
                var d = $q.defer();

                var authHeader = response.headers().authorization;
                if (authHeader !== undefined && authHeader != null && authHeader.length > 0) {
                    var storageKey = $rootScope.$state.current.data.isPortal ? 'portalAuthorizationData' : 'internalAuthorizationData';
                    var authData = localStorageService.get(storageKey);
                    if (authData !== undefined && authData != null) {
                        authData.access_token = authHeader.split(" ")[1];
                        localStorageService.set(storageKey, authData);
                    }
                }

                if (response.config.url.startsWith(apiLocation + '/api/')) {
                    convertDateStringsToDates(response.data);
                    if (--loadingCount == 0) $rootScope.$broadcast('loading:finish');
                }

                d.resolve(response);
                return d.promise;
            },

            responseError: function(response){

                if (response.config.url.startsWith(apiLocation + '/api/')) {
                    if (--loadingCount == 0) $rootScope.$broadcast('loading:finish');
                }
                if (response.data != null && response.data.error_uri != null) {
                    if (response.data.error_uri.indexOf('http') != 0) { // check whether angular state, or full url
                        if ($rootScope.$state.current.name == response.data.error_uri) {
                            // we're staying on the same page, but we need to "reload" to get any error messages loaded in
                            var params = $rootScope.$state.current.params;
                            params.messages = [response.data.error_description];
                            $rootScope.$state.transitionTo($rootScope.$state.current, params, {
                                reload: true,
                                inherit: false,
                                notify: true
                            });
                        }
                        else {
                            $rootScope.$state.go(response.data.error_uri, {messages: [response.data.error_description], keepMessages: true});
                            return $q.resolve(response);
                        }
                    }
                    else {
                        // if full url, could be coldfusion page, or could be reset password page. If reset password, we want error message passed through, which we can't do through a $window.location call
                        if (response.data.error_uri.indexOf('/reset/') > -1) {
                            var url = response.data.error_uri.substring(0, response.data.error_uri.lastIndexOf('/'));
                            var token = url.substring(url.lastIndexOf('/') + 1, url.length + 1);
                            $rootScope.$state.go('portal.menus.resetpassword', { token: token, messages: [response.data.error_description], keepMessages: true });
                        }
                        else {
                            $window.location.href = response.data.error_uri;
                        }
                    }
                }
                else {

                }

                return $q.reject(response.data);
            }
        }
    }])
    ;